const rateSetting = {
  path: 'rate-setting',
  component: resolve => require(['../../../../../pages/merchant/rate-setting'], resolve),
  meta: {
    requireAuth: true
  }
}

export default rateSetting
